import { getData, postData } from '@/utils/http';
import config from '@/config';

export default {
  namespaced: true,
  state: {
    tableLoading: true,
    addLoading: false,
    activeItem: null,
    tableList: [],
    deptId: '',
    innerQuery: {
      name: '',
      carNo: '',
      projectId: '1',// 1:内部 0:外部
      page: 1,
      size: config.pageSize,
    },
    outQuery: {
      name: '',
      carNo: '',
      pageIndex: 1,
      projectId: '0',// 1:内部 0:外部
      page: 1,
      size: config.pageSize,
    },
    pageSize: config.pageSize, 
    projectId: '1',// 1:内部 0:外部
    total: 0,
  },
  mutations: {
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, changeData) {
      if (changeData) {
        state.tableList = changeData.data?.rows;
        state.total = changeData.total;
      } else {
        state.tableList = [];
        state.total = 0;
      }
    },
    CHANGE_ACTIVE_ITEM(state, item) {
      state.activeItem = item;
    },
    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state[changeData['changeKey']] = [changeData['data']];
      } else {
        state[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_INNER_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state.innerQuery[changeData['changeKey']] = [changeData['data']];
      } else {
        state.innerQuery[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_OUT_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state.outQuery[changeData['changeKey']] = [changeData['data']];
      } else {
        state.outQuery[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_TABLE_INDEX(state, value) {
      state.pageIndex = value;
    },
    CHANGE_PROJECT_ID(state, value) {
      console.log(value);
      state.projectId = value;
    },
  },
  actions: {
    //获取驾驶员车辆绑定列表
    getList({ commit, state }, deptId) {
      return new Promise((resolve) => {
        let parmar = {};
        if (state.projectId == '1') {
          parmar = state.innerQuery;
        } else {
          parmar = state.outQuery;
        }
        getData(`logistics/driver/car/bind/page?deptId=${deptId}`, parmar).then(
          (res) => {
            if (res.state == 1) {
              commit('CHANGE_TABLE_DATA', res);
              resolve({
                state: 1,
                msg: '操作成功',
              });
            } else {
              commit('CHANGE_TABLE_DATA', null);
              resolve({
                state: 0,
                msg: res.msg,
              });
            }
          },
        );
      });
    },
    //获取可以选择的驾驶员列表
    getDriverList({}, data) {
      return new Promise((resolve) => {
        getData(
          `logistics/driver/car/driver/page?name=${data.name}&deptId=${data.deptId}&projectId=${data.projectId}&page=${data.pageIndex}&size=${config.pageSize}`,
        ).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              data: res.data,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },

    //获取可以选择的车辆列表
    getCarList({}, data) {
      return new Promise((resolve) => {
        getData(
          `logistics/driver/car/page?carNo=${data.carNo}&deptId=${data.deptId}&projectId=${data.projectId}&page=${data.pageIndex}&size=${config.pageSize}`,
        ).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              data: res.data,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              data: null,
              msg: res.msg,
            });
          }
        });
      });
    },

    //添加
    add({}, addData) {
      return new Promise((resolve) => {
        postData(`logistics/driver/car/bind`, addData).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    unBind({ commit, state }) {
      return new Promise((resolve) => {
        postData(`logistics/driver/car/unbind/${state.activeItem.id}`).then(
          (res) => {
            if (res.state == 1) {
              resolve({
                state: 1,
                msg: '操作成功',
              });
            } else {
              resolve({
                state: 0,
                msg: res.msg,
              });
            }
          },
        );
      });
    },

    getAllowOrg({ commit, state }, year) {
      return new Promise((resolve) => {
        getData(`logistics/sys/dept/get/list`).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
              data: res.data,
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
              data: [],
            });
          }
        });
      });
    },

    //写入当前操作条目
    setActiveItem({ commit }, item) {
      commit('CHANGE_ACTIVE_ITEM', item);
    },

    //写入查询条件
    setInnerSearchData({ commit }, changeData) {
      commit('CHANGE_INNER_SEARCH_COLL', changeData);
    },
    setOutSearchData({ commit }, changeData) {
      commit('CHANGE_OUT_SEARCH_COLL', changeData);
    },
    //修改分页
    setPageIndex({ commit }, value) {
      commit('CHANGE_TABLE_INDEX', value);
    },
    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    setSearchData({ commit }, changeData) {
      commit('CHANGE_SEARCH_COLL', changeData);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
  },
};
